import { pageBlocks } from './editor';
import { blockKind, type Block, type LensDocument } from './types';

export function viewBlocks(document: LensDocument): Array<Block> {
  return pageBlocks(document.page).filter((block) => blockKind(block) === 'view');
}

export type HtmlBoardTarget = { viewId: string; block: Block };

export function htmlBoardTarget(document: LensDocument): HtmlBoardTarget | undefined {
  if (document.display.board !== 'html') return undefined;
  const blocks = viewBlocks(document);
  const named = document.display.view;
  if (named) {
    const block = blocks.find((block) => block.view === named);
    if (!block || !document.views[named]) return undefined;
    return { viewId: named, block };
  }
  if (blocks.length !== 1) return undefined;
  const viewId = typeof blocks[0].view === 'string' ? blocks[0].view : '';
  if (!viewId || !document.views[viewId]) return undefined;
  return { viewId, block: blocks[0] };
}

export function pinnedHtmlView(document: LensDocument): string | undefined {
  const blocks = viewBlocks(document);
  const named = document.display.view;
  if (named) return blocks.some((block) => block.view === named) && document.views[named] ? named : undefined;
  if (blocks.length !== 1) return undefined;
  const viewId = typeof blocks[0].view === 'string' ? blocks[0].view : undefined;
  return viewId && document.views[viewId] ? viewId : undefined;
}
